export default __webpack_public_path__ + "static/media/avatar_cow6.1341ff20.mp3";